import { Turbo } from '@hotwired/turbo-rails';

async function fetchTurboStream(url, options = {}) {
  const response = await fetch(url, {
    method: options.method || 'GET',
    body: options.body,
    headers: {
      'X-CSRF-Token': document.head.querySelector('[name~=csrf-token][content]').content,
      Accept: 'text/vnd.turbo-stream.html'
    }
  });

  if (response.ok) {
    Turbo.renderStreamMessage(await response.text());
  }

  return response;
}

export { fetchTurboStream }; /* eslint-disable-line import/prefer-default-export */
